module.exports = __webpack_public_path__ + "static/img/17062B_1_2_R_20210813_fit.8eb252d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17062B_1_2_R_20210813_fit.png
// module id = H4Zb
// module chunks = 0